import ShopAsCustomerModal from './Modals/ShopAsCustomerModal'
import { ModalStore } from '../state/ModalStore'
import {
    getErrorMessage,
    _canLoginAsCustomer,
    _isImpersonated,
} from '../helpers/utils'
import { UserStore } from '../state/UserStore'
import { XIcon } from '@heroicons/react/outline'
import { logoutAsCustomer } from '../helpers/account'
import { useEffect, useState } from 'react'
import Loader from './Loader'
import ErrorAlert from './Alerts/ErrorAlert'
// import CountdownTimer from './CountDownTimer'

function TopBar({ user }) {
    const addModal = ModalStore((state) => state.add)

    const [canLoginAsCustomer, setCanLoginAsCustomer] = useState(false)
    const [isImpersonated, setImpersonated] = useState(false)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    const setUser = UserStore((state) => state.save)

    const handleShopAsCustomer = () => {
        addModal(<ShopAsCustomerModal />)
    }
    const handleLogoutAsCustomer = async () => {
        try {
            setLoading(true)
            const user = await logoutAsCustomer()
            setUser(user)
            location.reload()
        } catch (e) {
            setError(getErrorMessage(e))
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        setCanLoginAsCustomer(_canLoginAsCustomer())
        setImpersonated(_isImpersonated())
    }, [user])

    return (
        <div className="mb-2">
            {loading && <Loader />}

            {/* bg-gradient-to-r from-secondary to-primary */}
            {/* <div className="bg-secondary">
                <div className="container m-auto">
                    <div className="text-white items-center flex space-x-3 justify-center p-2 py-4 text-center font-medium">
                        <span>
                            🚀 Discover Off-Market Deals with Direct Mail. Act
                            Now for Exclusive Access.
                        </span>
                    </div>
                </div>
            </div> */}

            {(canLoginAsCustomer || isImpersonated) && (
                <div className="bg-gradient-to-r bg-gray-700 mb-2">
                    <div className="container m-auto">
                        <div className="text-white p-2 flex justify-between">
                            <div>
                                You are logged in as
                                {isImpersonated
                                    ? ` ${user.display_name} #${user.ID}`
                                    : ` ${user.role}`}
                            </div>
                            {isImpersonated ? (
                                <button
                                    className="hover:underline flex items-center space-x-2"
                                    onClick={handleLogoutAsCustomer}>
                                    <span>Logout as {user.display_name}</span>
                                    <XIcon className="h-5- w-5" />
                                </button>
                            ) : (
                                <button
                                    className="hover:underline"
                                    onClick={handleShopAsCustomer}>
                                    Shop as customer
                                </button>
                            )}
                        </div>
                        {error && <ErrorAlert error={error} />}
                    </div>
                </div>
            )}
        </div>
    )
}

{
    /* <div className='h-6 bg-gradient-to-r from-secondary to-primary mb-2'></div> */
}

export default TopBar
